import * as idb from "idb-keyval";

// Guard the missing global (sandboxed webviews, SSR) and swallow late throws so cache
// persistence degrades to a no-op instead of crashing.
const hasIndexedDB = typeof indexedDB !== "undefined";

export const idbStorage = {
  getItem: async (key: string): Promise<string | null> => {
    if (!hasIndexedDB) return null;
    try {
      return (await idb.get<string>(key)) ?? null;
    } catch {
      return null;
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    if (!hasIndexedDB) return;
    try {
      await idb.set(key, value);
    } catch {
      // ignore
    }
  },
  removeItem: async (key: string): Promise<void> => {
    if (!hasIndexedDB) return;
    try {
      await idb.del(key);
    } catch {
      // ignore
    }
  },
};
